<script setup lang="ts">
defineProps<{
  largeImage?: string
  title: string
  largeImageCopyright?: string | null
}>()
</script>

<template>
  <div class="relative">
    <NuxtImg
      class="h-auto w-full rounded-lg"
      fetch-priority="high"
      :src="largeImage"
      :alt="title"
      sizes="320px sm:400px md:770px lg:1200px xl:975px"
    />
    <div v-if="largeImageCopyright" class="ImageCopyright">
      {{ largeImageCopyright }}
    </div>
  </div>
</template>
